import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const ExpandIcon = styled(MUIIcon.ExpandMore)``;
